import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import * as _ from 'lodash';

import template from './AssignPopup.rt'
import * as Actions from './Actions';
import {getStoneFiltersValuesByType, saveFiltersForEntities} from "../FiltersActions";
import {getSelectedStones} from "./Reducer";
import {unwindHierarchy} from "../../../utilities/helpers";

const mapStateToProps = state => {
  const {filtersAssignToStones} = state;
  return {
    stones: getSelectedStones(filtersAssignToStones)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    closePopup: () => dispatch(Actions.showAssignPopup(false)),
    getStoneFiltersValuesByType: (type, callback) => dispatch(getStoneFiltersValuesByType(type, callback)),
    saveFiltersForEntities: (entityType, entitiesIDs, filterGroupValues) =>
      dispatch(saveFiltersForEntities(entityType, entitiesIDs, filterGroupValues))
  }
}

class AssignPopup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      excludedStones: {},
      materialsFilterGroup: {},
      colorsFilterGroup: {}
    }
  }

  componentDidMount() {
    this.props.getStoneFiltersValuesByType('materials', filterGroup => {
      this.setState({materialsFilterGroup: filterGroup});
      this.props.getStoneFiltersValuesByType('colors', filterGroup => {
        this.setState({colorsFilterGroup: filterGroup});
      });
    });
  }

  excludeStone = (stone) => {
    const {excludedStones} = this.state;
    if (excludedStones[stone.id])
      delete excludedStones[stone.id];
    else
      excludedStones[stone.id] = true;

    this.setState({excludedStones});
  }

  handleFilterClick = (item, type) => {

  }

  handleSave = () => {
    const entititesIDs = _.filter(this.props.stones, s => !this.state.excludedStones[s.id]).map(_ => _.id);
    const filterGroupValues = {};
    filterGroupValues[this.state.materialsFilterGroup.id] =
      _.filter(unwindHierarchy(this.state.materialsFilterGroup.values, _ => _.values),
        _ => _.checked).map(_ => _.id);
    filterGroupValues[this.state.colorsFilterGroup.id] =
      _.filter(unwindHierarchy(this.state.colorsFilterGroup.values, _ => _.values),
        _ => _.checked).map(_ => _.id);

    this.props.saveFiltersForEntities('stone', entititesIDs, filterGroupValues);
    this.props.closePopup();
  }

  render() {
    return template.apply(this);
  }
}

AssignPopup.propTypes = {
  getStoneFiltersValuesByType: PropTypes.func.isRequired
}

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(AssignPopup);
